import PropTypes from "prop-types";

// Hooks
import useQueryParam from "@/Common/hooks/Router/useQueryParam";

// Layouts
import AppSideBar from "@/Layouts/components/SideBars/AppSideBar";
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";
import BodyLayer from "@/Layouts/components/Layers/BodyLayer";

// Images
import empty from "@/assets/images/commons/empty.png";

export default function AssignmentsHistory(props) {
	const {
		children,
		expanded = [],
		tree = [],
		selected = null,
		selectBy = "_id",
		emptyTitle = "No item selected",
		loading = false,
		isLocationAvailable = false,
		isUserPosition = false,
		onActionSelected = () => {},
	} = props;

	const queryParam = useQueryParam();

	const handleSelection = (element) => {
		if (element?.[selectBy] !== selected?.[selectBy]) {
			if (isUserPosition) {
				queryParam.delete("selected");
			}
			onActionSelected?.(element);
		}
	};

	return (
		<BodyLayer
			fixedContent={
				<AppSideBar
					searchProps={{
						loading: loading || !isLocationAvailable,
					}}
					sideBarProps={{
						expanded,
						tree: tree || [],
						loading: loading || !isLocationAvailable,
						selected: selected?._id || "",
						onSelectAction: handleSelection,
					}}
				/>
			}
		>
			{selected && isLocationAvailable ? (
				<>{children}</>
			) : (
				<RoundedBox sx={{ minHeight: "630px" }}>
					<EmptyBody image={empty} title={emptyTitle} bodyHeight={"510px"} />
				</RoundedBox>
			)}
		</BodyLayer>
	);
}
AssignmentsHistory.propTypes = {
	children: PropTypes.node,
	expanded: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	tree: PropTypes.array,
	selected: PropTypes.object,
	selectBy: PropTypes.string,
	emptyTitle: PropTypes.string,
	loading: PropTypes.bool,
	isLocationAvailable: PropTypes.bool,
	isUserPosition: PropTypes.bool,
	onActionSelected: PropTypes.func,
};
